import { Avatar } from '@/components/Avatar'
import styles from './WorkspaceOpportunityListItem.module.css'
import {
  OpportunityItem,
  OpportunityItemAvatarInfo,
  OpportunityItemAvatar,
  OpportunityItemInfo,
  OpportunityItemTitle,
  OpportunityItemSubtitle,
  ForwardIcon,
} from '@/features/opportunities/components/OpportunityItem'
import cx from 'classnames'
import type { Id } from '@/infra/id'

export interface WorkspaceOpportunityListItemProps {
  opportunityId: Id
  isDisabled: boolean
  selected: boolean
  onSelect: () => unknown
  jobTypes: string
  requirements: string
  isApplicant: boolean
  isActive: boolean
  isInReview: boolean
}

export function WorkspaceOpportunityListItem({
  opportunityId,
  isDisabled,
  selected,
  onSelect,
  jobTypes,
  requirements,
  isApplicant,
  isActive,
  isInReview,
}: WorkspaceOpportunityListItemProps) {
  return (
    <OpportunityItem
      onSelect={onSelect}
      selected={selected}
      testId={'workspace-opportunity-list-item-' + opportunityId}
      isDisabled={isDisabled}
    >
      <OpportunityItemAvatarInfo>
        <OpportunityItemAvatar
          isDisabled={isDisabled}
          avatar={
            <Avatar
              subject={{
                avatar: undefined,
              }}
            />
          }
        />
        <OpportunityItemInfo>
          <OpportunityItemTitle
            title={'Firm Opportunity'}
            isDisabled={isDisabled}
          />
          <OpportunityItemSubtitle>
            <span className={styles.jobTypes}>{jobTypes}</span>
            {' | '}
            <span>{requirements || 'No description'}</span>
          </OpportunityItemSubtitle>
        </OpportunityItemInfo>
      </OpportunityItemAvatarInfo>
      {isApplicant && (
        <span
          className={cx(
            styles.applicationStatus,
            isActive && styles.active,
            isInReview && styles.inReview,
          )}
        >
          {isActive && 'Applied to opportunity'}
          {isInReview && 'Application in review'}
        </span>
      )}
      <ForwardIcon
        selectColor={isInReview ? 'green' : 'blue'}
        isDisabled={isDisabled}
      />
    </OpportunityItem>
  )
}
